import { gql } from "@apollo/client";





export const GET_EMAIL_LOG_BY_ORG_AND_DATE = gql`
query EmailLogsByOrgAndDate($orgId: Int, $startDate: String, $endDate: String, $screenName: String) {
  emailLogsByOrgAndDate(orgId: $orgId, startDate: $startDate, endDate: $endDate, screenName: $screenName) {
    Id
    userId
    orgId
    to
    subject
    emailContent
    screenName
    mailStatus
    inVoiceId
    leadId
    userName{
      firstName
      lastName
    }
    createdAt
  }
}
`